import en from './languages/en.json';

export const translations = {
  en,
};
